// extracted by mini-css-extract-plugin
export default {"container":"ProjectsPage_container__Twq0-","categoryTitle":"ProjectsPage_categoryTitle__M9YMW"};